/**
 * 不依赖服务端，纯前端控制的状态
 * 从 store 拆出来的原因，避免 service、models、store 循环依赖
 * @author
 */
import { init, RematchRootState, RematchDispatch } from '@rematch/core';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

interface State {
  loading: boolean;
}

const initState: State = {
  loading: false
};

const common = {
  state: initState,

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    }
  }
};

const models = {
  common
};

const store = init({
  models
});

export default store;

export type Store = typeof store;
export type RootModel = typeof models;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;

export const useRematchState = <S extends RootState, MS>(
  state: (state: S) => MS
) => {
  const mapState = useSelector(state, shallowEqual);
  return mapState;
};

export const useRematchDispatch = <D extends Dispatch, MD>(
  selector: (dispatch: D) => MD
) => {
  const dispatch = useDispatch<D>();
  return selector(dispatch);
};
